import React, { FC } from 'react';
import { Text, View } from 'react-native';
import Loading from '@components/loading';
import Batch from '@components/machines/components/detailsComponents/activeMachine/components/Batch/Batch';
import { scale } from '@components/frame';
import ColorWrapper from '@styles/colors';
import { NOT_PANEL_VIEW_MODE_WIDTH } from '@v2/pages/common/constants/base.constants';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import { useManageRunningBatch } from './hooks/useManageRunningBatch';
import type { WithColor } from '@styles/colors';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

export interface RunningBatchProps extends WithColor {
  noMachine: boolean;
  maxDetailsWidth?: number;
  batchLoading: boolean;
  batchLoadedTime: string;
  loadBatch: () => void;
  withImages?: boolean;
  currentBatchId: string | number | undefined;
  bg?: string;
}

const RunningBatch: FC<RunningBatchProps> = (props) => {
  const {
    C,
    noMachine,
    maxDetailsWidth = scale(NOT_PANEL_VIEW_MODE_WIDTH),
    batchLoading,
    withImages,
    bg,
  } = props;

  const {
    selectedItem,
    batch,
    panelViewMode,
    detailsWidth,
    batchForRender,
  } = useManageRunningBatch(props);

  return (
    <View style={{ flex: 1, width: '100%', alignItems: 'center' }}>
      <View
        style={[
          {
            flex: 1,
            flexDirection: panelViewMode ? 'row' : 'column',
            width: '100%',
            maxWidth: maxDetailsWidth,
          },
        ]}
      >
        <View
          style={[
            {
              width: '100%',
              flex: 1,
            },
          ]}
        >
          {!batchForRender && (
            <View testID={TEST_IDS.runningBatch.loading} style={{ marginTop: scale(40) }}>
              <Loading background="transparent" />
            </View>
          )}
          {!batchLoading && !batch.data && (
            <View style={{ flex: 1 }}>
              <Text testID={TEST_IDS.runningBatch.notFound} style={[font.Body, { color: C('Label/Light/Primary'), textAlign: 'center' }]}>
                {i18n.t('Not found')}
              </Text>
            </View>
          )}
          {batchForRender && (
            <Batch
              {...{
                ...props,
                batch: batchForRender,
                selectedItem,
                panelViewMode,
                noMachine,
                maxDetailsWidth,
                id: selectedItem?.machineStatus?.productionBatchId,
                detailsWidth,
                withImages,
                bg,
              }}
            />
          )}
        </View>
      </View>
    </View>
  );
};

export default ColorWrapper(RunningBatch);
